export default __webpack_public_path__ + "static/media/earlySubscriberIOS_5.47dd45ab.svg";